module.exports = __webpack_public_path__ + "img/质量标准 - 副本.56c1d560.svg";